import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  showCourseMessage,
  fetchCourseContentResponse,
} from "../actions/PreviewCourse";
import { FETCH_COURSE_CONTENT } from "../constants/ActionTypes";
import api from "../services/api";

function* fetchCourseContentRequest({ payload }) {
  try {
    const fetchedMail = yield call(
      api.get,
      `api/Admin/GetCourseContentAsync/${payload}`
    );
    // debugger
    yield put(fetchCourseContentResponse(fetchedMail));
  } catch (error) {
    yield put(showCourseMessage(error));
  }
}

function* fetchDocument({ payload }) {
  try {
    const response = yield call(api.get, "api");
  } catch (error) {}
}
export default function* rootSaga() {
  yield all([takeEvery(FETCH_COURSE_CONTENT, fetchCourseContentRequest)]);
}
